import videojs from 'video.js'

/*
 * Neccecary to use same condition in multiple places
 * This should control
 * - volume bar is shown
 * - tap to unmute is shown
 * - default volume level
 */
export const isMobile = () => {
  return videojs.browser.TOUCH_ENABLED
}
